module.exports = __webpack_public_path__ + "img/icon_3_9.674832f1.png";